import { render, staticRenderFns } from "./RobotModal.vue?vue&type=template&id=55598e03&scoped=true"
import script from "./RobotModal.vue?vue&type=script&lang=js"
export * from "./RobotModal.vue?vue&type=script&lang=js"
import style0 from "./RobotModal.vue?vue&type=style&index=0&id=55598e03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55598e03",
  null
  
)

export default component.exports